import * as types from "./mutation-types";
import { cnpj_empty } from "./getters";
import { merge } from "lodash";

export default {
  [types.SET_CNPJS](state, payload) {
    state.cnpjs = payload;
  },
  [types.SET_CNPJ](state, payload) {
    payload = merge(cnpj_empty(), payload);
    state.cnpj = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
